/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowShapeDRadiusDownRightIcon16Light } from './ArrowShapeDRadiusDownRightIcon16Light';
import { ArrowShapeDRadiusDownRightIcon16Regular } from './ArrowShapeDRadiusDownRightIcon16Regular';
import { ArrowShapeDRadiusDownRightIcon16Solid } from './ArrowShapeDRadiusDownRightIcon16Solid';
import { ArrowShapeDRadiusDownRightIcon20Light } from './ArrowShapeDRadiusDownRightIcon20Light';
import { ArrowShapeDRadiusDownRightIcon20Regular } from './ArrowShapeDRadiusDownRightIcon20Regular';
import { ArrowShapeDRadiusDownRightIcon20Solid } from './ArrowShapeDRadiusDownRightIcon20Solid';
import { ArrowShapeDRadiusDownRightIcon24Regular } from './ArrowShapeDRadiusDownRightIcon24Regular';
import { ArrowShapeDRadiusDownRightIcon24Solid } from './ArrowShapeDRadiusDownRightIcon24Solid';
import { ArrowShapeDRadiusDownRightIcon32Regular } from './ArrowShapeDRadiusDownRightIcon32Regular';
import { ArrowShapeDRadiusDownRightIcon64Regular } from './ArrowShapeDRadiusDownRightIcon64Regular';
var sizes = {
    16: {
        light: ArrowShapeDRadiusDownRightIcon16Light,
        regular: ArrowShapeDRadiusDownRightIcon16Regular,
        solid: ArrowShapeDRadiusDownRightIcon16Solid,
    },
    20: {
        light: ArrowShapeDRadiusDownRightIcon20Light,
        regular: ArrowShapeDRadiusDownRightIcon20Regular,
        solid: ArrowShapeDRadiusDownRightIcon20Solid,
    },
    24: {
        regular: ArrowShapeDRadiusDownRightIcon24Regular,
        solid: ArrowShapeDRadiusDownRightIcon24Solid,
    },
    32: {
        regular: ArrowShapeDRadiusDownRightIcon32Regular,
    },
    64: {
        regular: ArrowShapeDRadiusDownRightIcon64Regular,
    },
};
export var ArrowShapeDRadiusDownRightIcon = forwardRef('ArrowShapeDRadiusDownRightIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
